﻿import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static get targets() {
        return ["schemeId", "differentCountryAlertContainer"];
    }

    displayDifferentCountryAlertContainer({ target }) {
        const schemeId = parseInt(this.schemeIdTarget.value);
        const selectedCountry = target.options[target.selectedIndex].value;
        this.differentCountryAlertContainerTarget.classList.toggle(
            "d-none",
            !selectedCountry || ((schemeId !== 182 || selectedCountry === "DE") && (schemeId !== 156 || selectedCountry === "GB"))
        );
    }
}